import {LOCALE_ID, NgModule} from '@angular/core';
import {CommonModule, DatePipe, registerLocaleData} from '@angular/common';

import {MaintenanceRoutingModule} from './maintenance-routing.module';
import {TranslocoModule, TranslocoService} from '@ngneat/transloco';
import {MaintenanceComponent} from './maintenance.component';
import {AlarmOverviewComponent} from './alarm-overview/alarm-overview.component';
import {ButtonModule} from 'primeng/button';
import {CalendarModule} from 'primeng/calendar';
import {SidebarModule} from 'primeng/sidebar';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TableModule} from 'primeng/table';
import {CustomCommonModule} from 'src/app/common/common.module';
import {RadioButtonModule} from 'primeng/radiobutton';
import {DialogModule} from 'primeng/dialog';
import {ChipsModule} from 'primeng/chips';
import {TreeSelectModule} from 'primeng/treeselect';
import {MultiSelectModule} from 'primeng/multiselect';
import {TagModule} from 'primeng/tag';
import {TabMenuModule} from 'primeng/tabmenu';
import {AlarmDefinitionComponent} from './alarm-definition/alarm-definition.component';
import {AlarmDefinitionFormComponent} from './alarm-definition/alarm-definition-form/alarm-definition-form.component';
import {DropdownModule} from 'primeng/dropdown';
import {SharedComponentsModule} from '../shared/shared-components.module';
import {SkeletonModule} from 'primeng/skeleton';
import localeEs from '@angular/common/locales/es';
import localeEn from '@angular/common/locales/en';
import localeDe from '@angular/common/locales/de';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';
import {PendingChangesGuard} from 'src/app/common/can-deactivate/pending-changes-guard.service';
import {CheckboxModule} from "primeng/checkbox";

registerLocaleData(localeEs, 'es');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeDe, 'de');
registerLocaleData(localeFr, 'fr');
registerLocaleData(localeIt, 'it');

@NgModule({
  declarations: [
    MaintenanceComponent,
    AlarmOverviewComponent,
    AlarmDefinitionComponent,
    AlarmDefinitionFormComponent
  ],
  imports: [
    CommonModule,
    MaintenanceRoutingModule,
    TranslocoModule,
    ButtonModule,
    CalendarModule,
    SidebarModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    RadioButtonModule,
    DialogModule,
    ChipsModule,
    TreeSelectModule,
    DropdownModule,
    MultiSelectModule,
    TagModule,
    TabMenuModule,
    SkeletonModule,
    CustomCommonModule,
    SharedComponentsModule,
    CheckboxModule
  ],
  providers: [
    {
      provide: LOCALE_ID,
      deps: [TranslocoService],
      useFactory: (translocoService) => translocoService.getActiveLang()
    },
    DatePipe,
    PendingChangesGuard
  ]
})
export class MaintenanceModule {
}
